import React from "react";

/** returns a header page */
export const CustomAlert = ({ type, message }) => {
  return (
    <div className={'row'}>
      <div className={'col-sm-12'}>
        {
          type === "SUCCESS" && <div className="alert alert-success" role="alert" style={{fontSize: 'initial'}}>
            <strong>Success! </strong> {message}
          </div>
        }
        {
          type === "PROCESSING" && <div className="alert alert-warning" role="alert" style={{fontSize: 'initial'}}>
            <strong>Processing... </strong> {message}
          </div>
        }
        {
          type === "ERROR" && <div className="alert alert-danger" role="alert" style={{fontSize: 'initial'}}>
            <strong>Error! </strong> {message}
          </div>
        }
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/modules/AppCore/Component/Notification/CustomAlert.js